import React, { useState, useEffect } from 'react';
import API from '../../Services/BaseService';
import Terms from '../../Component/TermsAndCondition/TermsAndCondition';
import Popup from '../../Component/Popup/Popup';
import TermsCondition from '../../Component/Popup/TermsPopup';
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import StateAndCityRegistration from '../../Component/StateAndCity/StateAndCityRegistration';
import AppStoreImg from '../../../src/assets/img/appstore.png';
import GooglePlayImg from '../../../src/assets/img/googleplay.png';
import adduser from '../../assets/img/adduser.jpg'
import '../Registration/Registration.css'
import PhoneInput from 'react-phone-number-input/input';
import { $CombinedState } from 'redux';
import { set, useForm } from "react-hook-form";
import PhoneInputs from 'react-phone-input-2';
import PageNotFound from '../FallBackUI/PageNotFound';
import { Modal, Button } from 'react-bootstrap';


const Registration = () => {

  const [sellerName, setSellerName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [sslno, setSslno] = useState("");
  const [stateName, setStateName] = useState("");
  const [cityName, setCityName] = useState("");
  const [zipCodeId, setZipcodeId] = useState("");
  const [type, setType] = useState("");
  const [doc, setDoc] = useState("");
  const [terms, setTerms] = useState("0");
  const [eterms, setETerms] = useState("0");
  const [isOpen, setIsOpen] = useState(false);
  const [countryId, setCountryId] = useState("");
  const [optionExtn, setOptionExtn] = useState("");
  const [country, setCountry] = useState("");
  const [isChecked, setIsChecked] = useState(false);



  const [otherEmail, setOtherEmail] = useState("")

  const [newPhoneNumber, setNewPhoneNumber] = useState("")
  const [years, setYears] = useState("");

  const [isCommonPopupOpen, setIsCommonPopupOpen] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupMsg, setPopupMsg] = useState("");
  const [popupType, setPopupType] = useState("");
  const [popupActionType, setPopupActionType] = useState("");
  const [popupActionValue, setPopupActionValue] = useState("");
  const [popupActionPath, setPopupActionPath] = useState("");

  const [idStatename, setIdStatename] = useState(null);
  const [idCityname, setIdCityname] = useState(null);
  const [idZipcodename, setidZipcodename] = useState(null);
  const [stateCityFlag, setStateCityFlag] = useState("");


  const [sellerNameError, setSellerNameError] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [sslError, setSslError] = useState("");
  const [stateAndCityError, setStateAndCityError] = useState("");
  const [yearsError, setYearsError] = useState("");

  const [phoneNo, setPhoneNo] = useState([{ "id": `phoneNo${0}`, "phone_no": "", "extentation": "", "country_code": "+1" }]);
  const [email, setEmail] = useState([{ "id": `email${0}`, "value": "" }]);
  const [fields, setFields] = useState([{ "id": `email${0}`, "value": "" }]);
  const [phoneFields, setPhoneFields] = useState([{ "id": `phoneNo${0}`, "phone_no": "", "extentation": "", "country_code": "+1" }]);
  const [changesArray, setChangesArray] = useState([]);

  var _ = require('lodash');


  const [buyEmailsList1, setBuyEmailsList1] = useState([]);
  const [buyEmailsList2, setBuyEmailsList2] = useState([]);

  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);
  const [extentation, setExtentation] = useState("");
  const [originalValues1, setOriginalValues1] = useState({});
  const [originalValues, setOriginalValues] = useState({});
  const [originalEmailValues, setOriginalEmailValues] = useState({})
  const [changesFlag, setChangesFlag] = useState("no");
  const [originalValues2, setOriginalValues2] = useState({});
  console.log("changesArray", changesArray)

  const getBuyEmail = () => {

    API.post("selleremaillists/condition").then((response) => {
      if (response.data.success === true) {
        setBuyEmailsList1(response.data.data);
        setBuyEmailsList2(response.data.data1);
      }
      else {
        setErrors(response.data.error)
        setErrorFlag(true)
      }

    })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
        }
      });
  }

  useEffect(() => {
    getBuyEmail();
  }, [])


  const getFiles = (file) => {
    setType("")
    if (file.type.includes("jpg") || file.type.includes("jpeg") || file.type.includes("png")) {
      setDoc(file);
    } else {
      setType("0");
    }
  }

  const togglePopup = () => {
    setIsOpen(!isOpen);
  }

  const toggleCommonPopup = () => {
    setIsCommonPopupOpen(!isCommonPopupOpen);
  }

  function formatMobileNO(value) {
    var x = value.replace(/\D/g, '').match(/(\d{1})(\d{3})(\d{3})(\d{4})/);

    value = '+' + x[1] + '(' + x[2] + ')' + x[3] + '-' + x[4];
    return value;
  }



  const handleAdd = () => {
    const length = fields.length
    let object1 = {
      "oldvalue": "",
      "newvalue": "",
      "name": "Alternative Email",
      "id": `email${length}`,
      "flag": "Add"
    };

    changesArray.push(object1);
    const values = [...fields, { "value": "" }];
    setFields(values.map((data, index) => { return { "id": `email${index}`, value: data.value } }));
    setEmail(values.map((data, index) => { return { "id": `email${index}`, value: data.value } }));
  }
  const onhandleEmail = (e, emailId, index) => {
    const id = emailId;
    const value = e.target.value;
    const updatedOriginalValues = { ...originalEmailValues };

    if (!email.length) {
      setEmail([{ ...email, id, value }]);
      setFields([{ id, value }]);
      updatedOriginalValues[id] = value;
      setOriginalEmailValues({ [id]: "" });


    } else {
      const findIndex = email.findIndex((myData) => myData.id === id);

      if (findIndex >= 0) {
        let emailData = [...email];

        if (!updatedOriginalValues.hasOwnProperty(id)) {
          updatedOriginalValues[id] = emailData[findIndex].value;
        }

        emailData[findIndex].value = value;
        // setOtherEmail(value);
        setEmail(emailData);
        setFields(emailData);
        setChangesFlag("yes");
        setOriginalEmailValues(updatedOriginalValues);

        const existingChangeIndex = changesArray.findIndex(
          (change) => (change.name === "Alternative Email" || change.name === "Primary Email") && change.id === id
        );

        if (existingChangeIndex !== -1) {
          const updatedChangesArray = [...changesArray];
          updatedChangesArray[existingChangeIndex] = {
            oldvalue: updatedOriginalValues[id],
            newvalue: value,
            name: index == 0 ? "Primary Email" : "Alternative Email",
            id,
            flag: !updatedOriginalValues[id] ? "Add" : "Edit",
          };
          setChangesArray(updatedChangesArray);
        } else {
          const change = {
            oldvalue: updatedOriginalValues[id],
            newvalue: value,
            name: index == 0 ? "Primary Email" : "Alternative Email",
            id,
            flag: !updatedOriginalValues[id] ? "Add" : "Edit",
          };
          setChangesArray([...changesArray, change]);
        }
      } else {
        setEmail([...email, { id, value }]);
        setFields([...email, { id, value }]);

        setChangesFlag("yes");
        const change = {
          oldvalue: "",
          newvalue: value,
          name: index == 0 ? "Primary Email" : "Alternative Email",
          id,
        };
        setChangesArray([...changesArray, change]);
      }
    }
  };

  const removeFields = (index, id) => {
    setChangesFlag("yes")

    let data = [...email];
    let removedEmail = data[index].value == null ? "" : data[index].value;

    data.splice(index, 1);
    setEmail(data.map((data, index) => ({ ...data, "id": `email${index}`, value: data.value })));

    let value = [...fields];
    value.splice(index, 1);
    setFields(value.map((data, index) => ({ ...data, "id": `email${index}`, value: data.value })));
    const indexToRemove = changesArray.findIndex(obj => (obj.id == id) && (obj.flag == "Add"));

    if (indexToRemove !== -1) {
      let remainingArrays = changesArray.filter(obj => obj.id !== id);
      const updatedObjects = remainingArrays.map(obj => {
        const numericPart = parseInt(obj.id?.match(/\d+$/)[0]);
        if (numericPart > index) {
          return { ...obj, id: obj.id.startsWith('email') ? `email${numericPart - 1}` : obj.id };
        }
        return obj;
      });
      setChangesArray(updatedObjects)
    }
    else {
      if (removedEmail.trim() !== "") {
        let remainingArrays = changesArray.filter(obj => obj.id !== id);
        const updatedObjects = remainingArrays.map(obj => {
          const numericPart = parseInt(obj.id?.match(/\d+$/)[0]);
          if (numericPart > index) {
            return { ...obj, id: obj.id.startsWith('email') ? `email${numericPart - 1}` : obj.id };
          }
          return obj;
        });
        setChangesArray(updatedObjects)
        setChangesArray((prevChangesArray) => [
          ...prevChangesArray,
          { oldvalue: removedEmail, newvalue: "Alternative Email " + `${removedEmail}` + " has been removed", name: "Alternative Email", flag: "Remove" },
        ]);
      }

    }
  };

  const handlePhoneAdd = () => {
    const length = phoneFields.length

    let object1 = {
      "oldvalue": "",
      "newvalue": "",
      "name": "Alternative Phone #",
      "id": `phoneNo${length}`,
      "flag": "Add"
    };
    let object2 = {
      "oldvalue": "",
      "newvalue": "",
      "name": "Alternative Phone # Extension",
      "id": `phoneNo${length}`,
      "flag": "Add"
    };
    changesArray.push(object1, object2);
    const values = [...phoneFields, { "phone_no": "", "extentation": "", "country_code": "+1", flag: "add" }];
    setPhoneFields(values.map((data, index) => { return { "id": `phoneNo${index}`, "phone_no": data.phone_no, "extentation": data.extentation, "country_code": data.country_code } }));
    setPhoneNo(values.map((data, index) => { return { "id": `phoneNo${index}`, "phone_no": data.phone_no, flag: data.flag, "extentation": data.extentation, "country_code": data.country_code } }));
  }
  console.log("phoneFields", phoneFields);
  console.log("phoneNo", phoneNo);

  const handleOnChange = (data, phnId, index) => {
    const id = phnId;
    const phone_no = data;
    const updatedOriginalValues = { ...originalValues };
    if (!phoneNo?.length) {
      setPhoneNo([{ ...phoneNo, id, phone_no }]);
      setPhoneFields([{ id, phone_no }]);
      updatedOriginalValues[id] = phone_no;
      setOriginalValues({ [id]: "" });
    } else {
      const findIndex = phoneNo.findIndex((myData) => myData.id === id);
      if (findIndex >= 0) {
        let phoneNoData = phoneNo;
        if (!updatedOriginalValues.hasOwnProperty(id)) {
          updatedOriginalValues[id] = phoneNoData[findIndex].phone_no;
        }
        phoneNoData[findIndex].phone_no = phone_no;
        setPhoneNo(phoneNoData);
        setPhoneFields(phoneNoData);
        setChangesFlag("yes");
        setOriginalValues(updatedOriginalValues);
        const existingChangeIndex = changesArray.findIndex(
          (change) => (change.name === "Alternative Phone #" || change.name === "Primary Phone #") && change.id === id
        );
        if (existingChangeIndex !== -1) {
          const updatedChangesArray = [...changesArray];
          updatedChangesArray[existingChangeIndex] = {
            oldvalue: updatedOriginalValues[id],
            newvalue: phone_no,
            name: index == 0 ? "Primary Phone #" : "Alternative Phone #",
            id,
            flag: !updatedOriginalValues[id] ? "Add" : "Edit"
          };
          setChangesArray(updatedChangesArray);
        } else {
          const change = {
            oldvalue: updatedOriginalValues[id],
            newvalue: phone_no,
            name: index == 0 ? "Primary Phone #" : "Alternative Phone #",
            id,
            flag: !updatedOriginalValues[id] ? "Add" : "Edit"
          };
          setChangesArray([...changesArray, change]);
        }
      } else {
        setPhoneNo([...phoneNo, { id, phone_no }]);
        setPhoneFields([...phoneNo, { id, phone_no }]);

        setChangesFlag("yes");
        const change = {
          oldvalue: "",
          newvalue: phone_no,
          name: index == 0 ? "Primary Phone #" : "Alternative Phone #",
          id,
        };
        setChangesArray([...changesArray, change]);
      }
    }
  };

  const removePhoneFields = (index, id) => {
    let data = [...phoneNo];

    let removedPhone = data[index].phone_no == null ? "" : data[index].phone_no;
    let removedPhone1 = data[index].extentation == undefined || data[index].extentation == null ? "" : data[index].extentation;
    let removedPhone2 = data[index].country_code == undefined || data[index].country_code == null ? "" : data[index].country_code;

    data.splice(index, 1)
    setPhoneNo(data.map((data, index) => ({ ...data, "id": `phoneNo${index}`, phone_no: data.phone_no })));
    let value = [...phoneFields];
    value.splice(index, 1)
    setPhoneFields(value.map((data, index) => ({ ...data, "id": `phoneNo${index}`, phone_no: data.phone_no, })));

    const indexToRemove = changesArray.findIndex(obj => (obj.id == id) && (obj.flag == "Add"));

    if (indexToRemove !== -1) {
      let remainingArrays = changesArray.filter(obj => obj.id !== id);
      const updatedObjects = remainingArrays.map(obj => {
        const numericPart = parseInt(obj.id?.match(/\d+$/)[0]);
        if (numericPart > index) {
          return { ...obj, id: obj.id.startsWith('phoneNo') ? `phoneNo${numericPart - 1}` : obj.id };
        }
        return obj;
      });
      setChangesArray(updatedObjects)
    }
    else {
      let remainingArrays = changesArray.filter(obj => obj.id !== id);
      const updatedObjects = remainingArrays.map(obj => {
        const numericPart = parseInt(obj.id?.match(/\d+$/)[0]);
        if (numericPart > index) {
          return { ...obj, id: obj.id.startsWith('phoneNo') ? `phoneNo${numericPart - 1}` : obj.id };
        }
        return obj;
      });

      const newChanges = [];

      if (removedPhone.trim() !== "") {
        newChanges.push({ oldvalue: removedPhone, newvalue: "Alternative Phone # " + `${removedPhone}` + " has been removed", name: "Alternative Phone #", flag: "Remove" });
      }

      if (removedPhone1.trim() !== "") {
        newChanges.push({ oldvalue: removedPhone1, newvalue: "Alternative Phone # Extension " + `${removedPhone1}` + " has been removed", name: "Alternative Phone # Extension", flag: "Remove" });
      }

      if (removedPhone2.trim() !== "") {
        newChanges.push({ oldvalue: removedPhone2, newvalue: "Alternative Phone # Country Code " + `${removedPhone2}` + " has been removed", name: "Alternative Phone # Country Code", flag: "Remove" });
      }

      setChangesArray([...updatedObjects, ...newChanges]);


    }
  }


  const emailValidate = /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i;

  const phoneValidate = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

  const registrationhandleSubmit = (event, index) => {

    // setOpenLoader(true);
    event.preventDefault();
    setSellerNameError("")
    setFirstNameError("")
    setLastNameError("")
    setPhoneNumberError("")
    setEmailError("")
    setAddressError("")
    setSslError("")
    setStateAndCityError("")
    setYearsError("");

    phoneNo.map((data, index) => {
      document.getElementById(`phoneErr${index}`).innerHTML = "";
    })
    email.map((data, index) => {
      document.getElementById(`emailErr${index}`).innerHTML = "";
    })

    if (!sellerName) {
      setSellerNameError("Dealer Name is required")
      return;
    }
    else if (sellerName.length > 50) {
      setSellerNameError("Dealer Name must not exceed 50 characters")
      return;
    }
    if (!firstName) {
      setFirstNameError("First Name is required")
      return;
    }
    else if (firstName.length > 50) {
      setFirstNameError("First Name must not exceed 50 characters")
      return;
    }
    if (!lastName) {
      setLastNameError("Last Name is required")
      return;
    }
    else if (lastName.length > 50) {
      setLastNameError("Last Name must not exceed 50 characters ")
      return;
    }

    if (phoneNo[0].phone_no === "" || phoneNo[0].phone_no === undefined) {
      document.getElementById(`phoneErr${0}`).innerHTML = "Phone # is required";
      return;
    }
    if (phoneNo[0].phone_no !== "" && phoneNo[0].phone_no.length < 10) {
      document.getElementById(`phoneErr${0}`).innerHTML = "Phone Number must have 10 digits";

      return;
    }
    const phoneFilter = phoneNo.filter((data, index) => data.phone_no?.length < 10)
    if (phoneFilter.filter((data, index) => data.phone_no !== "")?.length > 0) {
      phoneNo.map((data, index) => {
        // document.getElementById(`phoneErr${index}`).innerHTML = "";
        if (data.phone_no !== "" && data.phone_no.length < 10) {
          document.getElementById(`phoneErr${index}`).innerHTML = "Phone Number must have 10 digits";

          return;
        }
      })
      return;
    }
    if (phoneNo.length > 0) {
      const phoneFilter = phoneNo.filter((data, index) => !(data.country_code == "" || data.country_code == undefined))
      if (phoneFilter.filter((data, index) => data.phone_no == "")?.length > 0) {
        phoneNo.map((data, index) => {
          if (data.country_code !== "" && data.phone_no == "") {
            document.getElementById(`phoneErr${index}`).innerHTML = "Phone # is required";
            return;
          }
        })
        return;
      }
    }
    if (phoneNo.length > 0) {
      const phoneFilter = phoneNo.filter((data, index) => !(data.extentation == "" || data.extentation == undefined))
      if (phoneFilter.filter((data, index) => data.phone_no == "")?.length > 0) {
        phoneNo.map((data, index) => {
          if (data.extentation !== "" && data.phone_no == "") {
            document.getElementById(`phoneErr${index}`).innerHTML = "Phone # is required";
            return;
          }
        })
        return;
      }
    }


    if (phoneNo.length > 0) {
      for (let i = 0; i < phoneNo.length - 1; i++) {
        if (phoneNo[i].phone_no !== "") {
          for (let n = i + 1; n < phoneNo.length; n++) {
            // console.log(phoneNo[i].value, "phoneNo")
            // console.log(phoneNo[n].value, n, "phoneNos")
            if (phoneNo[i].phone_no === phoneNo[n].phone_no) {
              // console.log("same phoneNo entered", phoneNo[i].id, phoneNo[n].id);
              // document.getElementById(`phoneErr${phoneNo[n].id.slice(7)}}`).innerHTML = "Phone Number's should not be same";
              document.getElementById(`phoneErr${phoneNo[n].id.substring(phoneNo[n].id.length - 1)}`).innerHTML = "Phone Number's should not be same";

              return;
            }
          }
        } else {
          console.log("phone is Empty")
        }
      }
    }

    if (email[0].value === "" || email[0].value === undefined) {
      document.getElementById(`emailErr${0}`).innerHTML = "Email is required";
      return;
    }
    if (email.filter((data, index) => data.value && !new RegExp(/^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i).test(data.value)).length > 0) {
      // console.log("email 1st if calling");
      email.map((data, index) => {
        document.getElementById(`emailErr${index}`).innerHTML = "";
        // document.getElementById(`phoneErr${index}`).innerHTML = "";
        if (data.value && !new RegExp(/^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i).test(data.value)) {
          // console.log("email 2nd if Calling");
          document.getElementById(`emailErr${index}`).innerHTML = "Must match the Email format";
          return;
        }
      })
      return;
    }
    if (buyEmailsList1.find((data) => data.email === email[0].value))/* || buyEmailsList2.find((data) => data.email === email[0].value) */ {
      document.getElementById(`emailErr${0}`).innerHTML = "This Email already exists";
      return;
    }
    if (email.length > 0) {
      for (let i = 0; i < email.length - 1; i++) {
        if (email[i].value !== "") {
          for (let n = i + 1; n < email.length; n++) {
            // console.log(email[i].value, "email")
            // console.log(email[n].value, n, "emails")
            if (email[i].value === email[n].value) {
              // console.log("same email entered", email[i].id, email[n].id);
              document.getElementById(`emailErr${email[n].id.substring(email[n].id.length - 1)}`).innerHTML = "Email Id's should not be same";

              // document.getElementById(`emailErr${email[n].id.slice(5)}}`).innerHTML = "Email Id's should not be same";
              return;
            }
          }
        } else {
          console.log("email is Empty")
        }
      }
    }
    if (sslno.length > 0 && sslno.length < 11) {
      setSslError("SSN #  must have Nine Numbers");
      return;
    }
    if (!address) {
      setAddressError("Address is required")
      return;
    }
    else if (address.length > 150) {
      setAddressError("Address must not exceed 150 characters")
      return;
    }

    if (!address) {
      setAddressError("Address is required")
      return;
    }

    else if (address.length > 150) {
      setAddressError("Address must not exceed 150 characters")
      return;
    }


    if (!idStatename) {
      setStateAndCityError("1")
      return;
    }
    if (!idCityname) {
      setStateAndCityError("2")
      return;
    }
    if (!idZipcodename) {
      setStateAndCityError("3")
      return;
    }
    if (!years) {
      setYearsError("Number Of Years is required");
      return;
    }
    const phoneNoList = phoneNo?.filter((data) => data?.phone_no !== "")
    const phoneData = phoneNoList?.filter((data) => data?.phone_no !== undefined)
    const emailList = email?.filter((data) => data?.value !== "")
    const filteredChangesArray = changesArray.filter(change => !(change.newvalue === ''));
    const filteredChangesflag = filteredChangesArray.length > 0 ? "yes" : "no"

    let request = {
      active: 0,
      dealer_name: sellerName,
      first_name: firstName,
      last_name: lastName,
      // phonenolist: phoneData.map(data => data.value),
      phonenolist: phoneData.map(({ id, ...rest }) => rest),
      // phone_no:countryId == +1 ? formatMobileNO(phoneNumber):phoneNumber,
      emaillist: emailList.map(data => data.value),
      address: address,
      // state_id: stateName,
      // city_id: cityName,
      // zipcode_id: zipCodeId,
      state_id: stateCityFlag === "" ? idStatename : "",
      city_id: stateCityFlag === "" ? idCityname : "",
      zipcode_id: stateCityFlag === "" ? idZipcodename : "",
      state_name: stateCityFlag !== "" ? idStatename : "",
      city_name: stateCityFlag !== "" ? idCityname : "",
      zipcode: stateCityFlag !== "" ? idZipcodename : "",
      image: doc === "" ? "" : doc.length > 0 ? doc : [doc],
      // country_id: parseInt(countryId == "" ? 1 : countryId),
      country_id: 228,
      password: "",
      mobile_no: "",
      no_years: years,
      local_flag: 0,
      ssl_no: sslno,
      account_approved: "",
      extentation: extentation,
      historylist: filteredChangesArray,
      valuechanges: filteredChangesflag,

    };

    console.log("=====before API call", request, isChecked, type)
    console.log("isChecked", isChecked)
    // return
    if (isChecked === true) {
      API.post("sellerRegistration/add", request)
        // console.log("=====after API call", request)
        .then((response) => {
          if (response.data.success) {
            const { data } = response;
            console.log("registration response=>", response)
            toggleCommonPopup()
            setPopupTitle("Seller Registered successfully");
            setPopupMsg("Please Activate your account with the link shared to the given email Id");
            setPopupType("success");
            setPopupActionType("redirect");
            setPopupActionValue("ok");
            setPopupActionPath("/login")
          } else {
            const { data } = response;
            toggleCommonPopup()
            setPopupTitle("Error");
            setPopupMsg(data.error.err);
            setPopupType("error");
            setPopupActionType("close");
            setPopupActionValue("close");
          }
        }
        )
        .catch(function (error) {
          if (error.response) {
            setErrors(error.response.data.error)
            setErrorFlag(true)
          }
        });
    } else {
      setTerms(true);
    }

  }

  const getStateName = (stateData, flag, type) => {
    setChangesFlag("yes")
    const oldValue = "";

    setIdStatename(stateData)
    setStateCityFlag(flag)
    if (flag === "") {
      setIdCityname(null)
      setidZipcodename(null)
    }
    setChangesArray((prevChangesArray) => {
      const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);

      if (existingChangeIndex !== -1) {
        const updatedChangesArray = [...prevChangesArray];
        updatedChangesArray[existingChangeIndex] = { oldvalue: oldValue, newvalue: stateData, name: type };
        return updatedChangesArray;
      } else {
        const change = { oldvalue: oldValue, newvalue: stateData, name: type };
        return [...prevChangesArray, change];
      }
    });
  }

  const getCityName = (cityData, flag, type) => {
    setChangesFlag("yes")
    const oldValue = "";
    setIdCityname(cityData)
    if (flag === "") {
      setidZipcodename(null)
    }
    setChangesArray((prevChangesArray) => {
      const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);

      if (existingChangeIndex !== -1) {
        const updatedChangesArray = [...prevChangesArray];
        updatedChangesArray[existingChangeIndex] = {
          ...updatedChangesArray[existingChangeIndex],
          newvalue: cityData,
        };
        return updatedChangesArray;
      } else {
        const change = { oldvalue: oldValue, newvalue: cityData, name: type };
        return [...prevChangesArray, change];
      }
    });
  }

  const getZipCodeId = (zipData, flag, type) => {
    setChangesFlag("yes")
    const oldValue = "";
    setidZipcodename(zipData)
    setChangesArray((prevChangesArray) => {
      const existingChangeIndex = prevChangesArray.findIndex((change) => change.name === type);
      const updatedFlag = flag || 'dropdown';
      if (existingChangeIndex !== -1) {
        const updatedChangesArray = [...prevChangesArray];
        updatedChangesArray[existingChangeIndex] = { ...updatedChangesArray[existingChangeIndex], newvalue: zipData, flag: updatedFlag };
        return updatedChangesArray;
      } else {
        const change = { oldvalue: oldValue, newvalue: zipData, name: type, flag: updatedFlag };
        return [...prevChangesArray, change];
      }
    });
  }

  const getError = (data, flag) => {
    console.log("reg flag", data, flag);
    setErrors(data)
    setErrorFlag(flag)
  }



  useEffect(() => {
    setIdStatename(idStatename)
    setIdCityname(idCityname)
    setidZipcodename(idZipcodename)
  }, []);
  // console.log("sateCityFlag===========", sateCityFlag);
  const handleSSNChange = (e) => {
    const inputSSN = e.target.value.replace(/\D/g, "");
    const inputLength = inputSSN.length;

    let formattedSSN = "";

    if (inputLength > 0) {
      formattedSSN = inputSSN.slice(0, 3);
    }
    if (inputLength > 3) {
      formattedSSN += "-" + inputSSN.slice(3, 5);
    }
    if (inputLength > 5) {
      formattedSSN += "-" + inputSSN.slice(5, 9);
    }
    // setSslno(formattedSSN);
    const oldvalue = "";
    const newValue = formattedSSN
    setSslno(formattedSSN);
    const existingChangeIndex = changesArray.findIndex(change => change.name === 'SSN #');
    if (existingChangeIndex !== -1) {
      const updatedChangesArray = [...changesArray];
      updatedChangesArray[existingChangeIndex] = { oldvalue, newvalue: newValue, name: 'SSN #' };
      setChangesArray(updatedChangesArray);
    } else {
      const change = { oldvalue, newvalue: newValue, name: 'SSN #' };
      setChangesArray([...changesArray, change]);
    }

  };

  const onhandleExtentation = (data, phnId, index) => {
    const id = phnId;
    const data1 = data.replace(/\D/g, "");
    const extentation = data1;
    const updatedOriginalValues = { ...originalValues1 };
    if (!phoneNo?.length) {
      setPhoneNo([{ ...phoneNo, id, extentation }]);
      setPhoneFields([{ id, extentation }]);

      updatedOriginalValues[id] = extentation;
      setOriginalValues1({ [id]: "" });

    } else {
      const findIndex = phoneNo.findIndex((myData) => myData.id === id);
      if (findIndex >= 0) {
        let phoneNoData = phoneNo;
        if (!updatedOriginalValues.hasOwnProperty(id)) {
          updatedOriginalValues[id] = phoneNoData[findIndex].extentation;
        }

        phoneNoData[findIndex].extentation = extentation;
        setPhoneNo(phoneNoData);
        setPhoneFields(phoneNoData);
        setChangesFlag("yes");
        setOriginalValues1(updatedOriginalValues);
        const existingChangeIndex = changesArray.findIndex(
          (change) => (change.name === "Alternative Phone # Extension" || change.name === "Primary Phone # Extension") && change.id === id
        );

        if (existingChangeIndex !== -1) {
          const updatedChangesArray = [...changesArray];
          updatedChangesArray[existingChangeIndex] = {
            oldvalue: updatedOriginalValues[id],
            newvalue: extentation,
            name: index == 0 ? "Primary Phone # Extension" : "Alternative Phone # Extension",
            id,
            flag: !updatedOriginalValues[id] ? "Add" : "Edit"

          };
          setChangesArray(updatedChangesArray);
        } else {
          const change = {
            oldvalue: updatedOriginalValues[id],
            newvalue: extentation,
            name: index == 0 ? "Primary Phone # Extension" : "Alternative Phone # Extension",
            id,
            flag: !updatedOriginalValues[id] ? "Add" : "Edit"

          };
          setChangesArray([...changesArray, change]);
        }
      } else {
        setPhoneNo([...phoneNo, { id, extentation }]);
        setPhoneFields([...phoneNo, { id, extentation }]);

        setChangesFlag("yes");
        const change = {
          oldvalue: "",
          newvalue: extentation,
          name: index == 0 ? "Primary Phone # Extension" : "Alternative Phone # Extension",
          id,
        };
        setChangesArray([...changesArray, change]);
      }
    }
  };

  const handleInputChange = (e, fieldName) => {
    setChangesFlag("yes");
    let newValue = e.target.value;
    // if (fieldName === "Terms") {
    //   newValue = e.target.value === '1' ? "agreed terms" : "not agreed terms";
    // }
    const oldvalue = "";

    switch (fieldName) {
      case "Dealer Name":
        setSellerName(newValue);
        break;
      case "First Name":
        setFirstName(newValue);
        break;
      case "Last Name":
        setLastName(newValue);
        break;
      // case "Country Code":
      //   setOptionPhone(newValue);
      //   break;
      case "Address":
        setAddress(newValue);
        break;
      case "How many years":
        setYears(newValue);
        break;
      // case "Terms":
      //   setTerms(e.target.value);
      //   break;


      default:
        break;
    }

    const existingChangeIndex = changesArray.findIndex(change => change.name === fieldName);
    const newChange = { oldvalue, newvalue: newValue, name: fieldName };

    if (existingChangeIndex !== -1) {
      const updatedChangesArray = [...changesArray];
      updatedChangesArray[existingChangeIndex] = newChange;
      setChangesArray(updatedChangesArray);
    } else {
      setChangesArray([...changesArray, newChange]);
    }
  };
  const onhandleCode = (data, phnId, index) => {
    const id = phnId;
    // const data1 = data.replace(/\D/g, "");
    const country_code = data;
    const updatedOriginalValues = { ...originalValues2 };
    if (!phoneNo?.length) {
      setPhoneNo([{ ...phoneNo, id, country_code }]);
      setPhoneFields([{ id, country_code }]);

      updatedOriginalValues[id] = country_code;
      setOriginalValues2({ [id]: "" });

    } else {
      const findIndex = phoneNo.findIndex((myData) => myData.id === id);
      if (findIndex >= 0) {
        let phoneNoData = phoneNo;
        if (!updatedOriginalValues.hasOwnProperty(id)) {
          updatedOriginalValues[id] = phoneNoData[findIndex].country_code;
        }

        phoneNoData[findIndex].country_code = country_code;
        setPhoneNo(phoneNoData);
        setPhoneFields(phoneNoData);
        setChangesFlag("yes");
        setOriginalValues2(updatedOriginalValues);
        const existingChangeIndex = changesArray.findIndex(
          (change) => (change.name === "Alternative Phone # Country Code" || change.name === "Primary Phone # Country Code") && change.id === id
        );

        if (existingChangeIndex !== -1) {
          const updatedChangesArray = [...changesArray];
          updatedChangesArray[existingChangeIndex] = {
            oldvalue: updatedOriginalValues[id],
            newvalue: country_code,
            name: index == 0 ? "Primary Phone # Country Code" : "Alternative Phone # Country Code",
            id,
            flag: !updatedOriginalValues[id] ? "Add" : "Edit"

          };
          setChangesArray(updatedChangesArray);
        } else {
          const change = {
            oldvalue: updatedOriginalValues[id],
            newvalue: country_code,
            name: index == 0 ? "Primary Phone # Country Code" : "Alternative Phone # Country Code",
            id,
            flag: !updatedOriginalValues[id] ? "Add" : "Edit"

          };
          setChangesArray([...changesArray, change]);
        }
      } else {
        setPhoneNo([...phoneNo, { id, country_code }]);
        setPhoneFields([...phoneNo, { id, country_code }]);

        setChangesFlag("yes");
        const change = {
          oldvalue: "",
          newvalue: country_code,
          name: index == 0 ? "Primary Phone # Country Code" : "Alternative Phone # Country Code",
          id,
        };
        setChangesArray([...changesArray, change]);
      }
    }
  };
  useEffect(() => fetchCountry()
    , [])

  async function fetchCountry() {
    const country = API.get('country');
    country.then((response) => {

      if (response.data.success === true) {
        setCountry(response.data.data);
      }
      else {
        setErrors(response.data.error.name)
        setErrorFlag(true)
      }

    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)
      }
    });
  }

  const handleAgreeClick = () => {

    setIsChecked(true);


    togglePopup();
  };
const handleFileChange = (event) => {
  const file = event.target.files[0];

  if (!file) return;

  setType("");

  if (
    file.type === "image/jpeg" ||
    file.type === "image/jpg" ||
    file.type === "image/png"
  ) {
    const reader = new FileReader();

    reader.onload = () => {
      const base64 = reader.result.split(",")[1];

      setDoc({
        name: file.name,
        type: file.type,
        size: file.size,
        base64,
      });
    };

    reader.readAsDataURL(file);
  } else {
    setType("0");
  }
};
  return (
    <div>
      <main id="main" className="inner-page">
        {errorFlag === true ? <PageNotFound error={errors} /> :
          <div className="col-lg-6 card loginBlock">
            <form className="registrationform" onSubmit={registrationhandleSubmit}>

              <h2 className="title"> Seller Registration</h2>

              <div className="row">
                <div className="col-sm-12 form-group upload">
                  <div className="user-upload-btn-wrapper">
                    {doc === "" ? (
                      <img alt="" src={adduser} />
                    ) : (
                      <img
                        alt=""
                        src={`data:${doc.type};base64,${doc.base64}`}
                      />
                    )}

                    <span className="proCamera"></span>

                    {type === "0" && (
                      <p className="form-input-error">
                        Upload only Image Format
                      </p>
                    )}

                    <input
                      type="file"
                      accept="image/jpeg,image/jpg,image/png"
                      onChange={handleFileChange}
                      hidden
                      id="profileUpload"
                    />

                    <label htmlFor="profileUpload" style={{ cursor: "pointer" }}>
                      Change Image
                    </label>
                  </div>
                </div>


                <div className="col-sm-12 form-group">
                  <div className="tbox">
                    <input className="textbox " type="text" placeholder="" id="dealer_name" name="dealerName"
                      onChange={(e) => handleInputChange(e, "Dealer Name")} /* onChange={(e) => setDealerName(e.target.value)} */ />
                    <label htmlFor="dealer_name" className={sellerName != "" ? "input-has-value required" : "required"}>Dealer Name</label>
                    <p className="form-input-error" >{sellerNameError}</p>
                  </div>
                </div>
                <div className="col-sm-12 form-group">
                  <div className="tbox">
                    <input className="textbox " type="text" placeholder="" id="first_name" name="firstName"
                      onChange={(e) => handleInputChange(e, "First Name")} /* onChange={(e) => setFirstName(e.target.value)} */ />
                    <label htmlFor="first_name" className={firstName != "" ? "input-has-value required" : "required"}>First Name</label>
                    <p className="form-input-error" >{firstNameError}</p>
                  </div>
                </div>
                <div className="col-sm-12 form-group">
                  <div className="tbox">
                    <input className="textbox " type="text" placeholder="" id="last_name" name="lastName"
                      onChange={(e) => handleInputChange(e, "Last Name")}  /* onChange={(e) => setLastName(e.target.value)} */ />
                    <label htmlFor="last_name" className={lastName != "" ? "input-has-value required" : "required"}>Last Name</label>
                    <p className="form-input-error" >{lastNameError}</p>
                  </div>
                </div>
                <div className="col-sm-4 form-group countrycode">
                  {phoneFields.map((data, index) =>
                    <div className="tbox">
                      <select className="form-control custom-select browser-default textbox" id="drop" placeholder=""
                        onChange={(e) => onhandleCode(e.target.value, `phoneNo${index}`, index)} value={data.country_code}
                      >
                        <option
                          style={{ display: "none" }}>{data.country_code}
                        </option>
                        {country.length > 0 &&
                          <>
                            {country.map((country) => <>
                              <option key={country.id} value={`+${country.country_code}`} >
                                {country?.country_name}({`+${country.country_code}`})
                              </option>
                            </>)}
                          </>}
                      </select>
                      <label for="drop" className={"input-has-value required"}>Country Code</label>

                    </div>
                  )}
                </div>

                <div className="col-sm-5 form-group">
                  {phoneFields.map((item, index) =>
                    <div className="tbox">

                      <PhoneInputs
                        className="textbox"
                        country={'us'}
                        disableDropdown={true}
                        disableCountryCode={true}
                        onlyCountries={['us']}
                        value={item.phone_no}
                        onChange={(data) => handleOnChange(data, `phoneNo${index}`, index)}
                        placeholder=""
                      ></PhoneInputs>
                      <label htmlFor={`phoneNo${index}`} className={"input-has-value required"}>{index === 0 ? "Primary Phone #" : "Alternative Phone #"}</label>
                      <p className="form-input-error" id={`phoneErr${index}`} ></p>

                    </div>
                  )}


                </div>

                <div className="col-sm-3 form-group">
                  {phoneFields.map((item, index) =>

                    <div className="tbox extn-code">
                      <input
                        type="text"
                        class="form-control"
                        id="extentation1"
                        value={item.extentation}
                        onChange={(e) => onhandleExtentation(e.target.value, `phoneNo${index}`, index)}

                      />
                      <label for="drop" className={"input-has-value"}>Extension</label>
                      {index === 0 ?

                        <button class="btn btn-outline-secondary rounded-1 ms-2" type="button" id="button-addon2" onClick={handlePhoneAdd}>+ </button>

                        :
                        <button className="btn btn-outline-secondary " type="button" id="button-lesson3" onClick={() => removePhoneFields(index, `phoneNo${index}`)}>- </button>



                      }
                    </div>
                  )}
                </div>



                <div className=" col-sm-10 form-group">
                  {fields.map((data, index) =>
                    <div className="tbox">


                      <input className="textbox" type="text" key={index} placeholder="" id={`email${index}`} name={`email${index}`}
                        value={data.value} onChange={(e) => onhandleEmail(e, `email${index}`, index)} />
                      <label htmlFor={`email${index}`} className={email != "" ? "input-has-value required" : ""}>{index === 0 ? "Primary Email" : "Alternative Email"}</label>

                      {index === 0 ?
                        <button class="btn btn-outline-secondary-2 rounded-1" type="button" id="button-addon2" onClick={handleAdd}>+ </button>
                        :
                        <button class="btn btn-outline-secondary-2 rounded-1 " type="button" id="button-lesson2" onClick={() => removeFields(index, `email${index}`)}> - </button>
                      }
                      <p className="form-input-error" id={`emailErr${index}`} ></p>

                    </div>

                  )}

                </div>
                <div className="col-sm-12 form-group">
                  <div className="tbox">
                    <input className="textbox " type="text" placeholder="" id="ssl" name="ssl"
                      onChange={handleSSNChange} value={sslno} />
                    <label htmlFor="ssl" className={sslno != "" ? "input-has-value" : ""}>SSN #</label>
                    <p className="form-input-error" >{sslError}</p>
                  </div>
                </div>
                <div className="col-sm-12 form-group">
                  <div className="tbox">
                    <input className="textbox " type="text" placeholder="" id="address" name="address"
                      onChange={(e) => handleInputChange(e, "Address")}  /* onChange={(e) => setAddress(e.target.value)} */ />
                    <label htmlFor="address" className={address != "" ? "input-has-value required" : "required"}>Address</label>
                    <p className="form-input-error" >{addressError}</p>
                  </div>
                </div>
                {/* <StateAndCityRegistration
                                setStateValue={getStateName}
                                setCityValue={getCityName}
                                setZipcodeValue={getZipCodeId}
                            /> */}
                <StateAndCityRegistration
                  // setStateValue={getnewStateName}
                  // setCityValue={getnewCityName}
                  // setZipcodeValue={getnewZipCodeId}
                  setStateValue={(stateData, flag) => getStateName(stateData, flag, 'state')}
                  setCityValue={(cityData, flag) => getCityName(cityData, flag, 'city')}
                  setZipcodeValue={(zipData, flag) => getZipCodeId(zipData, flag, 'zipcode')}
                  setNewError={getError}
                  stateCityValidation={stateAndCityError}
                />
                {/* <div className="col-sm-12 form-group mb-4">
                                <p className="form-input-error statecity"> {stateAndCityError}</p>
                            </div> */}

                <div className="col-sm-8 form-group ">
                  <div className="tbox">
                    {/* {/ <lable htmlFor="drop" className={option !="" ? "input-has-value" : ""}>How many years in car business</lable> /} */}
                    <select id="drop" placeholder="" className="form-control custom-select browser-default textbox"
                      onChange={(e) => handleInputChange(e, "How many years")}/* onChange={(e) => setOption(e.target.value)} */>
                      <option style={{ "display": "none" }}></option>
                      <option value="Less then 1">Less than 1</option>
                      <option value="1-3">1-3</option>
                      <option value="3-5">3-5</option>
                      <option value="5-10">5-10</option>
                      <option value="10-15">10-15</option>
                      <option value="15-20">15-20</option>
                      <option value="More then 20">More than 20</option>
                    </select>
                    <label htmlFor="no_years" className={"input-has-value required"}>How many years in car business</label>
                    <p className="form-input-error" >{yearsError}</p>
                  </div>
                </div>



                <div className="col-sm-12 form-group agreetab">
                  <input type="checkbox" className="form-check d-inline " id="chb"
                    checked={isChecked == false ? false : true} onChange={(e) => setIsChecked(e.target.checked ? true : false)} />
                  <label htmlFor="chb" className="form-check-label"> I Agree for the
                    <a href="#" onClick={togglePopup}>Terms And Conditions</a>
                  </label>
                  {isChecked === false && terms === true ?
                    <p className="form-input-error"> Agree the Terms And Conditions</p> : ""}

                  {isOpen && <TermsCondition
                    isClose={false}
                    content={<>

                      <Modal show={isOpen} onHide={togglePopup} centered >
                        <Modal.Header /* closeButton */ className="Terms-login">
                          <h2 >Terms And Conditions </h2>
                        </Modal.Header>
                        <Modal.Body className="modal-dialog-scrollable">
                          <div >
                            {/* <h2>Terms And Conditions </h2> */}
                            <h6 className='term-urs'>URS SECOND LOT</h6>
                            <p>
                              1.	The Ur2ndLot is Dealers only Auction. Absolutely no retail buyers are allowed on the premises.<br></br>
                              2.	All Dealers must be registered with this auction to buy or sell vehicles. Dealers must be registered before doing any business.<br></br>
                              3.	All cars purchased must be paid for on the day of the sale either by cash, check, of floor plan.<br></br>
                              4.	Absolutely – no children or anyone under 18 years of age on Auction grounds.<br></br>
                              5.	Auction place to trade automobile could be danger for our safety therefore enter auction on your risk.<br></br>
                              6.	Must follow come sense for the following:<br></br>
                              i.	Never stand between cars in auction building.<br></br>
                              ii.	You are solely responsible for your employees. Your workman’s comp. must cover you and your employees in case of injury.<br></br>
                              iii.Do not rise (rev the engine) any engine in the auction building...<br></br>
                              iv.	Make all mechanical inspection on the lot, not in auction building.<br></br>
                              v.	Do not hassle or hustle the drivers, while they are driving or are in a vehicle.<br></br>
                              vi.	Extreme caution must be used when walking around moving vehicles. Never turn you back to a moving vehicle.<br></br>
                              vii.Use extreme caution while you or your employees are driving on auction lot.<br></br>
                              viii.Do not consign any vehicle for sale with bad breaks, fuel leaks, or that start in gear without notifying Ur2ndLot of the problem first.<br></br>
                              7.	The dealer owner is the only person authorized to add or delete an Authorized representative.<br></br>
                              8.	Buyer must pay for vehicle in sale day with cash or a separate company check. The dealership name as indicated on the state license must be imprinted on the company check. No personal or second party checks can be accepted.<br></br>
                              9.	Cars left on the property must have their keys left in them. Auction is not responsible for any damage, theft or vandalism.<br></br>
                              10.	The dealer owner is responsible for retrieving an auction identification card in the event of deletion of an authorized representative.<br></br>
                              11.	The auction assumes absolutely no responsibility for mileage discrepancies. We are only an agent and are not the buyer or seller of cars.<br></br>
                              12.	No vehicle will be offered for sale without proper serial number identification or correct serial number plate.<br></br>
                              13.	All dealers and their representatives agree to follow the rules and arbitration polices of this auction at all times.<br></br>
                              14.	All titles submitted by seller must be in seller’s company name on title or reassignment form – alterations, erasures, or damaged titles will not be accepted.<br></br>
                              15.	All title attached “TA” sales must be announced. Failure to announce “TA” sales is grounds for rejection.<br></br>
                              16.	Seller must produce an assignable title within twenty eight (28) days.<br></br>
                              17.	Buyers are cautioned not to spend any money on “TA” cars until they receive the title. Buyer are also reminded that they are responsible for any physical or mechanical damage that occurs to the car while waiting for the titles. Ur2ndLot will not reimburse any expenses on vehicles returned for lack of titles.<br></br>
                              18.	After the 28th day the buyer may bring the car back. However, after the 28th day if the title reaches this auction prior to the vehicle being returned, a return will not be allowed. Buyer must notify the auction before the car return, without notice the auction will not be responsible if the seller presents the title in time been ( 3 days from notice otherwise it will be void return)<br></br>
                              19.	Buyer must check the car back in sell ( auction premises) for no title otherwise the buyer is responsible for automobile.<br></br>
                              20.	If the seller cannot produce a title and car is returned, the seller will be charged a $100.00 processing fee.<br></br>
                              21.	Salvage title, previous salvage titles, rebuilt salvage titles, or junk titles must be announced. (salvage titled vehicles can only be sold to salvage licensed dealers.)<br></br>
                              22.	All dealers must repurchased vehicles with undisclosed title history: i.e. salvage, fire, junk, rebuilt, theft recovery, flood, etc. buyers have 30 days to notify this auction regarding an undisclosed permanently branded title.<br></br>
                              23.	It is the seller’s obligation to correct any errors made by the auction as to announce “conditions” or information displayed on the vehicle or sale ticket.<br></br>
                              24.	Seller __ other than announced conditions are not binding on the auction. The auction will not be responsible for administrative errors.<br></br>
                              25.	Ur2ndLot reserves the right to void any transaction.<br></br>
                              26.	All cars needing fuel will be charged $9.00.<br></br>
                              27.	All vehicles are subject to search prior to leaving the auction.<br></br>
                              28.	All consigned vehicles must be run across the auction block. Any outside transactions must be consummated through Auction management. All sales will be strictly sold “as is”.<br></br>
                              29.	Buyers are urged to inspected vehicles prior to bidding. Visible flaws and defects; i.e. glass spare tires, body damage, etc. are not arbitratable.<br></br>
                              30.	The auction does not guarantee manufacturer’s warranty, warranty brooks or plates.<br></br>
                              31.	The test track is provided to allow an opportunity to determine general reliability issues. It is not to be used as a race track and/or as a tool to caused damage to a vehicle to allow for arbitration and/or rejection.<br></br>
                              32.	It is the buyer’s responsibility to pay attention to announcements when bidding on a car. If a buyer is unsure why a light is on the sale ticket.<br></br>
                              33.	Ur2ndLot does not guarantee years of trailers, boats, outboard motors, motorcycle, antique cars or recreational vehicles. These vehicles are always sold “as is.”<br></br>
                              34.	All dealers must have an approved gate pass in order to remove a vehicle from Ur2ndLot premises.<br></br>
                              35.	Vehicles left on auction premises are at the owner’s request and risk. All vehicles must have keys in them. Ur2ndLot will not be held responsible for loss or damage (including lost keys).<br></br>np
                              36.	Changes in dealer registration information such as ownership, authorized buyers, bank, or other pertinent information must be recorded in writing with Ur2ndLot.<br></br>
                              37.	Ur2ndLot will do everything possible to assist buyers and sellers. Under no circumstances will Ur2ndLot be obligated to buy or take possession of any vehicle for any reason.<br></br>
                              38.	All 10 years or older vehicle are sold AS IS – no guarantee unless noted otherwise on block ticket.<br></br>
                              39.	Buyers are responsible for verifying serial numbers and mileage and year reading on all purchases before leaving the sale.<br></br>
                              40.	When “Title Attached” is not announced at block – buyer has the right to reject vehicle day of sale.<br></br>
                              41.	Cars sold T/A must be sold with the correct mileage announced or a seller’s fee will apply.<br></br>
                              42.	If a purchased vehicle title has a correction affidavit attached, Ur2ndLot will not be held responsible if buyer’s state does not accept the correction affidavit.<br></br>
                              43.	 Ur2ndLot reserves the right to refuse business to anyone at anytime.<br></br>
                              44.	All if transaction is “one way Ifs” on selling price only. If selling price is agreed upon by seller, the “Buyer” owns the vehicle, subject to regular auction rules. Selling price must be within 11/2 hour of sale time or transaction then becomes a “2 way IF.” Fleet and lease IF’s are one way until 5:00 p.m on sale day.<br></br>
                              45.	NSF check fee is $150.00 plus check.<br></br>
                              46.	TA ARBITRATION – NO TITLE The buyer may return a vehicle for no title if the auction has not received a negotiable title from the seller by the end of 28 days). The buyer should use caution against selling or incurring costs, including freight, on any vehicle returned for TA arbitration. The buyer must notify the auction prior to a vehicle being returned. Vehicles should not be drive other than to and from the auction. There will be a $100 no title fee to the seller for all vehicles returned for no title.<br></br>
                            </p>
                            <h6>Odometers</h6>
                            <p>
                              The Ur2ndLot assumes absolutely no responsibility for the accuracy of odometer mileage or the validity of the mileage statement provide by the seller to the buyer. The seller must announce the following: ( failure to announce is grounds for rejection)<br></br>
                              ● If the odometer is not working properly.<br></br>
                              ● If he or she has any knowledge that mileage on the vehicle is different than what is on the odometer.<br></br>
                              ● Vehicles sold “as is” are not exempt from odometer requirements.<br></br>
                              ● All vehicles sold must comply with federal law. <br></br>
                              “Actual Miles”<br></br>
                              “Not Actual”<br></br>
                              “Miles Over” or “in Excess of mechanical limits”<br></br>
                              “Miles Exempt – Mileage Not required ( 10 years and older)<br></br>
                              ● Vehicles 10 years old and older not required odometer disclosure (Mileage Exempt) are automatically sold “as is” unless announced otherwise.<br></br>
                              ● It is the Buyer’s responsibility to verify that mileage on the odometer is as stated on the odometer statement. The buyer is also required to verify the odometer is working properly prior to leaving auctions premises. Announcing miles exempt takes precedence over all other odometer issue.<br></br>
                              ● In order to protect our costumer from buying vehicles with tampering odometers, we reserve the right to do the following: Suspend any Dealer guilty of knowingly selling vehicles with tampered odometers . Any Dealer, regardless of guilt, who sells a vehicle where odometer tampering can be confirmed, will be required to re-purchase the vehicle and reimburse the Buyer and Auction for handling expenses. Check all titles closely for alterations and erasures. If Ur2ndLot feels an altered title was knowingly presented for processing, the Dealer’s  trading privileges will be suspended.<br></br>
                              ▪Any vehicles with the emission control flag covering the odometer must be sold with NOT ACTUAL MILES.<br></br>
                              ▪Odometer operation must be verified on day of sale.<br></br>
                            </p>
                            <h6>Arbitration</h6>
                            <p>
                              All Arbitration manager’s decisions are final.<br></br>
                              All Arbitration concerns must be initiated through the arbitration.<br></br>
                              Office until 5:00 p.m. on sale day. THE BUYER AND SELLER MUST AWAIT THE ARBITRATOR’S DECISION BEFORE LEAVING THE AUCTION. After any accepted adjustment the vehicle automatically becomes “as is” and no further arbitration will be allowed.<br></br>
                            </p>
                            <h6>Arbitration Guarantee</h6>
                            <p>
                              Any car can be given an arbitration guarantee. Only the seller can assign an arbitration guarantee, and it must bee announced on the block. An arbitration guarantee gives the buyer the right to arbitrate the vehicle for the following items.<br></br>
                              ● Frame (7 days)**<br></br>
                              ● Transmission (day of sale)<br></br>
                              ● Rear end and transfer case (day of sale)<br></br>
                              ● Engine valve train*<br></br>
                              * Covers: Majors engine smoking and blow by, engine bearing failure, rod knocks, Compression failure, head gaskets, intake gasket, timing chain, and hard upper valve train noise.<br></br>
                              * Excludes: Minors smoking and blow by, oil leaks, lifter noise and external engine components<br></br>
                              ** Frame damage excludes damage to the core support, jack marks, tie downs, road hazard to the floor plan, frame rail extensions (ears) and bolt ons (NAAA structural damage policy applies)<br></br>
                              *** See exception under arbitration guarantee ,Suspension, steering, CV joints, air conditioning, glass, body damage, wheel bearings, charging systems, electric system, cooling system, 2 wheel drive or visual defects can not be arbitrated. Ur2ndLot reserves the right to change or amend these rules at any time with no written notice.<br></br>
                              1.	Missing catalytic converter and pollution equipment. (day of sale)<br></br>
                              2.	Air bag  deployed (expect if price blow $ 1499).<br></br>
                              3.	Commercial, municipal and flood vehicles.<br></br>
                              4.	Not actual or over 100,000 miles are AS IS regardless of year or price.<br></br>
                              5.	Salvage titles, previously junked, and previously salvage, reassignment of titles by insurance company regardless of price. (30 Day Limit).<br></br>
                              6.	Vehicles concerted from diesel to gas.<br></br>
                              7.	Ur2ndLot does not reimbursement freight, reconditioning or any expenses on arbitrated vehicles.<br></br>
                              8.	All buyers returning a vehicle for arbitration are responsible for the vehicle to be returned in the same condition in which it was purchased. The buyer must notify the auction prior to any vehicle being returnred.<br></br>
                            </p>
                            <h6>Ur2ndLot policy on sublet inspections</h6>
                            <p>
                              If a vehicle required an outside inspection to verify any arbitrable  condition, the  buyer will be responsible for inspection cost if no problems is found. If the conditions is verified, the seller will be responsible for the cost of the inspection.<br></br>
                              Vehicle sold “AS IS” are not arbitratable.* (Except must announce items)<br></br>
                              * Vehicles sold as is for over $4500 can be arbitrated for frame damage for 7 days.<br></br>
                              Unless the seller assigns an arbitration guarantee, all vehicles selling for $1500 or less, 100,000 miles or more, 10 or more years old, or miles unknown are automatically “as is” and not subject to arbitration (excluding must be announced conditions).<br></br>
                            </p>

                            <p>
                              Must Be Announced<br></br>
                              * Must be announced conditions apply to all cars – as is and arbitration guarantee. Failure to announce the following is grounds for rejection or return:<br></br>
                              28 days - Title attached (TA)<br></br>
                              7 Days - Frame damage or previous frame damage if sold for 4500.00 or over or Arbitration Guaranteed.<br></br>
                              Day of sale - Livery, Police or flood vehicles <br></br>
                              30 Day of sale - Missing catalytic converters, punched out fuel filler necks and  missing pollution pumps <br></br>
                              Day of sale - Broken and/or altered odometer ( not required if sold “mileage exempt” or “mileage not required”) <br></br>
                              Day of sale - Miles unknown or over 100,000 miles, Miles over 200,000 and 300,000 etc. <br></br>
                              30 days - limit applies to branded title- physical evidence of flood is arbitratable Day of sale Air bag deployed.<br></br>
                            </p>

                          </div>
                          <div className="modalfooter agree">
                            <button type="button" className="cta-btn-agree" data-bs-dismiss="modal" onClick={handleAgreeClick}>
                              I Agree
                            </button>
                          </div>
                        </Modal.Body>
                      </Modal>

                    </>}
                    handleClose={togglePopup}
                  />}
                  {isCommonPopupOpen && <CommonPopup
                    handleClose={isCommonPopupOpen}
                    popupTitle={popupTitle}
                    popupMsg={popupMsg}
                    popupType={popupType}
                    popupActionType={popupActionType}
                    popupActionValue={popupActionValue}
                    popupActionPath={popupActionPath}
                  />}
                </div>
                <div className="col-lg-12 loginBtn">
                  <button className="cta-btn">Submit</button>
                </div>
              </div>
            </form>

          </div>}
        <section id="playstoreBlock" className="playstoreBlock">
          <div className="container">
            <div className="row content">
              <div className="col-lg-12">
                <img src={AppStoreImg} />
                <img src={GooglePlayImg} />
              </div>
            </div>
          </div>
        </section>
      </main>

    </div>
  )
}

export default Registration;